import { KeyRound } from "lucide-react";
import { useProposalT } from "../i18n/ProposalI18nContext";
import type { LicenseFeePeriod } from "../../ai-mode/types";

interface LicenseFeeSectionProps {
  value: number;
  period: LicenseFeePeriod;
}

export function LicenseFeeSection({ value, period }: LicenseFeeSectionProps) {
  const { t } = useProposalT();

  if (value <= 0) return null;

  return (
    <div className="font-space-grotesk h-full">
      <div className="flex justify-center h-full">
        <div className="flex md:inline-flex w-full md:w-[24rem] gap-4 md:gap-6 items-center flex-wrap p-[18px_20px] rounded-[14px] bg-white border border-[#F0E9D8] h-full">
          <div className="w-9 h-9 rounded-[9px] bg-[#FFF3CC] border border-[rgba(184,134,11,0.2)] flex items-center justify-center shrink-0">
            <KeyRound className="w-4 h-4 text-[#B8860B]" strokeWidth={2.25} />
          </div>

          <div className="flex-1 min-w-0">
            <span className="block text-[11px] font-semibold tracking-[0.06em] uppercase text-[#B8860B] mb-[3px]">
              {t("licenseFee.title")}
            </span>
            <div className="flex items-baseline gap-[5px]">
              <span className="text-[22px] font-extrabold text-[#1A1814] tracking-[-0.02em] leading-none font-['Space_Grotesk',sans-serif]">
                R$ {value.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
              </span>
            </div>
            <p className="text-xs text-[#9E9A94] mt-[3px] font-normal">
              {period === "semiannual"
                ? t("licenseFee.paidSemiannually")
                : t("licenseFee.paidAnnually")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
